import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import { headerTunables, opacityTunables } from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    gridTunables,
    metaInfoTunables,
    xAxisTunables,
    yAxisTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import React from 'react';
import ActionCheckboxGroup from 'components/_UI/Forms/Actions/ActionCheckboxGroup';
import { widgetHasDim } from 'utils/Widget/WidgetUtils';
import ActionSliderGroup from 'components/_UI/Forms/Actions/ActionSliderGroup';

export const HyperSpaceBarChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => {
    const isTimeDim: boolean = widgetHasDim(widget, [
        'SN_CREATED_TIME',
        'measurementTime',
        'CREATED_DATE',
        'date',
    ]);
    return [
        {
            props: {
                label: i18n.t('Bar Chart'),
                startOpen: true,
            } as CollapseProps,
            children: [
                ...headerTunables(widget),
                opacityTunables(widget),
                gridTunables(widget),
                <ActionSliderGroup
                    key='barHeight'
                    label={i18n.t('Bar Height')}
                    showValue
                    option={widget.options}
                    value='barHeight'
                    min={25}
                    max={150}
                />,
            ],
        },
        metaInfoTunables({ widget, color: true, image: true }),
        xAxisTunables({ widget, ticks: false, mergedTheme, axisIsDim: false }),
        yAxisTunables({ widget, ticks: false, format: isTimeDim ? true : false, mergedTheme }),
    ];
};
